import { SlidersVertical } from '@sweep-io/sweep-design/dist/icons';
import { SingleSelectFilter } from '../../../common/filters/single-select-filter/SingleSelectFilter';
import { SingleSelectFilterPopoverOption } from '../../../common/filters/single-select-filter/SingleSelectFilterPopover';

export interface SearchFiltersProps {
  filterOptions: SingleSelectFilterPopoverOption[];
  selectedFilterValue: string;
  onSelectedFilterItem: (key: string) => void;
  menuOptions?: SingleSelectFilterPopoverOption[];
  selectedMenuOption?: string;
  onSelectMenuOption?: (selectedValue: string) => void;
}

export const SearchFilters = ({
  filterOptions,
  selectedFilterValue,
  onSelectedFilterItem,
  menuOptions,
  selectedMenuOption,
  onSelectMenuOption,
}: SearchFiltersProps) => (
  <SingleSelectFilter
    options={filterOptions}
    selectedItemValue={selectedFilterValue}
    onSelectItem={(key) => onSelectedFilterItem(key)}
    icon={<SlidersVertical size="medium" />}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    menuOptions={menuOptions}
    selectedMenuOption={selectedMenuOption}
    onSelectMenuOption={onSelectMenuOption}
  />
);
